import React, { useState } from 'react'
import Breadcrumb from '../Components/Breadcrumb'
import Pagehelmet from '../Components/Pagehelmet'
import axios from 'axios';
import { useParams, useNavigate,Link } from 'react-router-dom';

const Booknow = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  console.log(id, 'tickets')

  const headers = {
    Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
  };

  const url = `${process.env.REACT_APP_API_URL}/users/signin`

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    
    password: "",
   
 
    // email
    //   :
    //   "rrrrohadev2025@gmail.com",
    
    // password
    //   :
    //   "C858585c$$",
   
  })

  console.log(formData, 'formData')

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

   

    try {
      setLoading(true);

      // Prepare the data to send
      const payload = {
        ...formData
      
      };

      // Remove confirmpassword as it's not needed in the API call
 
      const response = await axios.post(url, payload, { headers });

      if (response.data) {
        setSuccess(true);
        // Redirect or show success message
        setTimeout(() => {
          navigate('/OTPSIGNIN', {
            state: {  // Correct property name is 'state' not 'formData'
              formData: formData,
              registrationResponse: response.data // Include API response if needed
            }
          });
        }, 2000);
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError(err.response?.data?.message || 'An error occurred during registration');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <Pagehelmet pageTitle="Sign In" />
      <Breadcrumb title="Sign In Now" />

      {/*--Book now Section start*/}
      <section className="ticket-booking">
        <div className="container">
          <div className="booking-form w-lg-75 m-auto px-2">
            <div className="form-title mb-4">
              <h2 className="mb-2"><span className="pink">Sign In </span> Now</h2>
              <p>Sign In To Get Tickets</p>
            </div>
            <div className="form-content">
              <form onSubmit={handleSubmit} className="max-w-3xl mx-auto p-4">
                {/* Error and Success Messages */}
                {error && (
                  <div className="alert alert-danger mb-4">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="alert alert-success mb-4">
                    Sign In successful! Redirecting...
                  </div>
                )}

                {/* Student Information */}
                <div className="row mb-4">
                  <h6 className="text-xl font-semibold mb-3">Personal Information</h6>

               

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="email" className="block mb-2">Email *</label>
                    <input
                      type="email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>

            
 

          

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="password" className="block mb-2">Password *</label>
                    <input
                      type="password"
                      id="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>
 
                </div>
 
                <div className="text-left mt-6">
                  <button
                    className="btn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Processing...' : 'Sign In Now'}
                  </button>
                </div>
              </form>
                 <Link to={`/SIGNUP/`} className="black">
                                                                       Do not Have Account SIGNUP Now
                                                                    </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Booknow